<template>
    <div>
        <div v-if="loading">
            <div class="spinner"></div>
        </div>

        <div v-else-if="errors.length" class="alert--error" >
            <p v-for="err in errors" :key="err"> {{ err }} </p>
        </div>

        <form v-if="!loading" class="form" @submit.prevent="save">
            <slot name="header"></slot>

            <div :class="wrapperClass">

                <div class="form__item">
                    <!-- <i class="form__icon icons icon-graduation"></i> -->
                    <vue-select
                        label="name"
                        :options="invoiceProducts"
                        v-model="item.invoice_product"
                        @input="updateDefaults"
                        :onSearch="search => newProductName = search"
                        :clearSearchOnSelect="!newProductToAdd"
                        class="form__select"
                        :class="{ 'has-value': item.invoice_product }" >
                        <template slot="no-options">
                            <span @click="addNewInvoiceProduct">
                                {{$t('forms.invoice_item.no_results_add')}}
                                <i class="icons icon-plus"></i>
                            </span>
                        </template>
                    </vue-select>
                    <label class="form__label">{{$t('forms.invoice_item.invoice_product')}}</label>
                </div>
                <div class="form__item">
                    <!-- <i class="form__icon icons icon-location-pin"></i> -->
                    <input v-model="item.vat_percentage" class="form__input--text" type="number" step="0.1" required :class="{ 'has-value': item.vat_percentage }"/>
                    <label class="form__label">{{$t('forms.invoice_item.vat_percentage')}}</label>
                </div>
                <div class="form__item">
                    <!-- <i class="form__icon icons icon-location-pin"></i> -->
                    <input v-model="item.unit_price" class="form__input--text" type="number" step="0.01" required :class="{ 'has-value': item.unit_price }"/>
                    <label class="form__label">{{$t('forms.invoice_item.unit_price')}}</label>
                </div>
                <div class="form__item">
                    <!-- <i class="form__icon icons icon-briefcase"></i> -->
                    <input v-model="item.count" class="form__input--text" type="text" :class="{ 'has-value': item.count }"/>
                    <label class="form__label">{{$t('forms.invoice_item.count')}}</label>
                </div>
            </div>

            <slot name="buttons" :isSaveDisabled="isSaveDisabled">
                <div class="form__buttons">
                    <button type="submit" class="form__button button--cta" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                </div>
            </slot>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop, Watch} from 'vue-property-decorator';
    import InvoiceItem from '@/models/InvoiceItem';

    import { LOAD_INVOICE_RESOURCES } from '@/store/modules/invoice-resources';

    import InvoiceProduct from '@/models/InvoiceProduct';

    @Component
    export default class InvoiceItemForm extends Vue {

        @Prop({ type: Array | String, default() {
            return [];
        } })
        wrapperClass;

        @Prop({ type: InvoiceItem, default() {
            return new InvoiceItem();
        } })
        item;

        created() {
            this.errors = [];
            this.$store.dispatch(LOAD_INVOICE_RESOURCES, {});
        }

        // Prevent vue-select from overriding the values at rendering.
        isFirstChange = true;
        updateDefaults(product) {
            let shouldOverride = !this.isFirstChange || (!this.item.unit_price || !this.item.vat_percentage);
            if (product && product.id > -1 && shouldOverride) {
                this.item.unit_price = product.default_price;
                this.item.vat_percentage = product.vat_percentage;
                // Cancel adding a new product when an already existing product is selected.
                this.newProductToAdd = false;
            }
            this.isFirstChange = !this.isFirstChange;
        }

        get isSaveDisabled() {
            return !this.item.invoice_product || !this.item.count || !this.item.unit_price || !this.item.vat_percentage;
        }

        saveLoading = false;

        get invoiceProducts() {
            return this.$store.state.invoice_resources.invoice_products;
        }

        newProductName = '';
        newProductToAdd = false;
        addNewInvoiceProduct() {
            this.newProductToAdd = true;
            this.item.invoice_product = { name: this.newProductName + ' (new)', id: -1 };
        }

        get loading () {
            return this.saveLoading || this.$store.state.invoice_resources.loading;
        }

        save() {
            this.errors = [];
            this.saveLoading = true;
            if (this.newProductToAdd) {
                this.saveNewProduct().then(this.saveItem);
            } else {
                this.saveItem();
            }
        }

        saveNewProduct() {
            const newProduct = new InvoiceProduct();
            newProduct.fill({ name: this.newProductName, default_price: this.item.unit_price, vat_percentage: this.item.vat_percentage});
            return newProduct.save().then(res => this.item.invoice_product = res);
        }

        saveItem() {
            this.errors = [];
            this.item.save()
                .then(res => this.$emit('saved', res))
                .catch(
                    err => {
                        if (err.status === 422) {
                            this.errors = err.errors;
                        } else {
                            this.errors = [this.$t('common.unknown_error')];
                        }
                    })
                .then(() => this.saveLoading = false);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/invoice-details/InvoiceItemForm.vue